const ITEMS = [
  "PM SURYA GHAR SUBSIDY UP TO ₹78,000",
  "TIER-1 N-TYPE BIFACIAL MODULES",
  "25-YEAR PERFORMANCE GUARANTEE",
  "100% DISCOM NET-METERING APPROVED",
  "0% INTEREST EMI AVAILABLE",
  "FREE SITE SURVEY & 3D DESIGN",
];

export const Marquee = () => (
  <section className="relative border-y border-gold/15 bg-ink py-5 overflow-hidden" aria-label="Highlights">
    <div className="flex w-max animate-marquee">
      {[0, 1].map((copy) => (
        <ul key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1}>
          {ITEMS.map((item, i) => (
            <li key={i} className="flex items-center">
              <span className="whitespace-nowrap font-mono text-[11px] sm:text-xs tracking-[0.25em] text-warm/70 px-8">
                {item}
              </span>
              <span className="h-1.5 w-1.5 rotate-45 bg-gold" aria-hidden="true" />
            </li>
          ))}
        </ul>
      ))}
    </div>
  </section>
);

export default Marquee;
